export const l_gallery_GridTemplateColumns_max = {
  "name": "--pf-v6-l-gallery--GridTemplateColumns--max",
  "value": "1fr",
  "var": "var(--pf-v6-l-gallery--GridTemplateColumns--max)"
};
export default l_gallery_GridTemplateColumns_max;